<template>
  <section class="d3:flex d3:justify-center d3:items-center d3:px-14">
    <div class="testi mb-16 d3:mb-0">
      <div class="imgDiv">
        <img src="../../assets/images/image-emily.jpg" />
      </div>
      <p class="">
        We put our trust in Sunnyside and they delivered, making sure our needs
        were met and deadlines were always hit.
      </p>
      <div class="id">
        <span class="name">Emily R.</span>
        <span class="post">Marketing Director</span>
      </div>
    </div>
    <div class="testi mb-16 d3:-mb-0">
      <div class="imgDiv">
        <img src="../../assets/images/image-thomas.jpg" />
      </div>
      <p class="">
        Sunnyside's enthusiasm coupled with their keen interest in our brand's
        success made it a satisfying and enjoyable experience.
      </p>
      <div class="id">
        <span class="name">Thomas S.</span>
        <span class="post">Chief Operating Officer</span>
      </div>
    </div>
    <div class="testi">
      <div class="imgDiv">
        <img src="../../assets/images/image-jennie.jpg" />
      </div>
      <p>
        Incredible end result! Our sales increased over 400% when we worked with
        Sunnyside. Highly recommended!
      </p>
      <div class="id">
        <span class="name">Jennie F.</span>
        <span class="post">Business Owner</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Testimony",
};
</script>
